import * as React from 'react';

function SvgFilterVerticalOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "square", strokeLinejoin: "round", strokeWidth: 1.6, d: "M6.444 11.444V22M17.556 12.556V2M6.444 2v2.222M17.556 22v-2.222" }),
        React.createElement("circle", { cx: 6.445, cy: 7.556, r: 3.333, stroke: "currentColor", strokeWidth: 1.6 }),
        React.createElement("circle", { cx: 17.555, cy: 16.445, r: 3.333, stroke: "currentColor", strokeWidth: 1.6, transform: "rotate(-180 17.555 16.445)" })));
}

export default SvgFilterVerticalOutline;
